import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import DashBoardPage from "../pages/dashboard/DashBoardPage";
import WebsiteAnalyticsPage from "../pages/analytics/WebsiteAnalyticsPage";
import PlayReviewsPage from "../pages/playReviews/PlayReviewsPage";
import PlayVitalsPage from "../pages/playVitals/PlayVitalsPage";
import MainLayout from "../components/layouts/MainLayout";
import ProtectedRoute from "./ProtectedRoute";
import { userRoles } from "../constants/userRoles";
import ForgetPasswordPage from "../pages/ForgetPasswordPage";
import SettingPage from "../pages/settings/SettingPage";
import SurnamePage from "../pages/settings/views/surname/SurnamePage";
import SurnameCreate from "../pages/settings/views/surname/SurnameCreate";
import SubCastPage from "../pages/settings/views/subCast/SubCastPage";
import SubCastCreate from "../pages/settings/views/subCast/SubCastCreate";
import GovtDepartmentPage from "../pages/settings/views/govtDepartment/GovtDepartmentPage";
import GovtDepartmentCreate from "../pages/settings/views/govtDepartment/GovtDepartmentCreate";
import BusinessTypePage from "../pages/settings/views/businessType/BusinessTypePage";
import BusinessTypeCreate from "../pages/settings/views/businessType/BusinessTypeCreate";
import BusinessCategoryPage from "../pages/settings/views/businessCategory/BusinessCategoryPage";
import BusinessCategoryCreate from "../pages/settings/views/businessCategory/BusinessCategoryCreate";
import RegDocPage from "../pages/settings/views/regDoc/RegDocPage";
import RegDocCreate from "../pages/settings/views/regDoc/RegDocCreate";
import RegTypePage from "../pages/settings/views/regType/RegTypePage";
import RegTypeCreate from "../pages/settings/views/regType/RegTypeCreate";
import ProductTypePage from "../pages/settings/views/productType/ProductTypePage";
import ProductTypeCreate from "../pages/settings/views/productType/ProductTypeCreate";
import BusinessMemTagPage from "../pages/settings/views/businessMemTag/BusinessMemTagPage";
import BusinessMemTagCreate from "../pages/settings/views/businessMemTag/BusinessMemTagCreate";
import BazarProductPage from "../pages/settings/views/bazarProduct/BazarProductPage";
import BazarProductCreate from "../pages/settings/views/bazarProduct/BazarProductCreate";
import LiveSupportPage from "../pages/liveSupport/LiveSupportPage";
import EducationRuleCreate from "../pages/settings/views/educationRule/EducationRuleCreate";
import EducationRuleTreeView from "../pages/settings/views/educationRule/EducationRuleTreeView";
import EducationRulePage from "../pages/settings/views/educationRule/EducationRulePage";
import SubAdminPage from "../pages/subAdmin/SubAdminPage";
import ReportActivitiesPage from "../pages/reportActivities/ReportActivitiesPage";
import ProfilePage from "../pages/profiles/ProfilePage";
import ProfileView from "../pages/profiles/ProfileView";
import AdvertisementPage from "../pages/advertisement/AdvertisementPage";
import AdvertisementAdd from "../pages/advertisement/AdvertisementAdd";
import NewLeadsPage from "../pages/newLeads/NewLeadsPage";
import BusinessPage from "../pages/business/BusinessPage";
import BusinessAdd from "../pages/business/BusinessAdd";
import BusinessView from "../pages/business/BusinessView";
import BusinessViewers from "../pages/business/BusinessViewers";
import MatriMonialPage from "../pages/matrimonial/MatriMonialPage";
import JobDescPage from "../pages/jobDesc/JobDescPage";
import JobAdd from "../pages/jobDesc/JobAdd";
import JobView from "../pages/jobDesc/JobView";
import JobViewers from "../pages/jobDesc/JobViewers";
import ProductPage from "../pages/products/ProductPage";
import ProductView from "../pages/products/ProductView";
import ProductViewers from "../pages/products/ProductViewers";
import ProductAdd from "../pages/products/ProductAdd";
import StoryPage from "../pages/stories/StoryPage";
import HomePage from "../pages/HomePage";
import PublicSitePage from "../pages/PublicSitePage";
import AboutusPage from "../pages/settings/views/aboutus/AboutusPage";
import PrivacyPolicyPage from "../pages/settings/views/privacypolicy/PrivacyPolicyPage";
import ContactusPage from "../pages/settings/views/contactus/ContactusPage";
import TermsandConditionPage from "../pages/settings/views/termandcondition/TermsandConditionPage";
import LiveVideoPage from "../pages/settings/views/liveVideo/LiveVideoPage";
import LiveVideoCreate from "../pages/settings/views/liveVideo/LiveVideoCreate";
import PageVideoPage from "../pages/settings/views/pageVideo/PageVideoPage";
import EventPage from "../pages/settings/views/event/EventPage";
import EventCreate from "../pages/settings/views/event/EventCreate";
import HomeContentPage from "../pages/settings/views/homeContent/HomeContentPage";
import ApplicationSettingsPage from "../pages/settings/views/applicationSettings/ApplicationSettingsPage";
import MatriMonialView from "../pages/matrimonial/MatriMonialView";

import BazarBhavPage from "../pages/settings/views/bazarBhav/BazarBhavPage";
import BazarBhavCreate from "../pages/settings/views/bazarBhav/BazarBhavCreate";
import BazarBhavView from "../pages/settings/views/bazarBhav/BazarBhavView";

import RegistrationCreateEn from "../pages/registration/RegistrationCreateEn";
import RegistrationCreateGu from "../pages/registration/RegistrationCreateGu";
import CreateAd from "../pages/razorpay/CreateAd";
import MyAdvertisements from "../pages/razorpay/MyAdvertisements";
import ActiveUsersPage from "../pages/activeUsers/ActiveUsersPage";
import ChatPage from "../pages/chat/ChatPage";
import ActiveUsersCards from "../pages/activeUsers/ActiveUsersCards";
import BloodGroupPage from "../pages/bloodGroup/BloodGroupPage";

import AdvertisementPakageCreate from "../pages/settings/views/advertisementPackage/AdvertisementPackageCreate";
import AdvertisementPakagePage from "../pages/settings/views/advertisementPackage/AdvertisementPackagePage";
import AdvertisementView from "../pages/advertisement/AdvertisementView";
import ScheduledNotificationsPage from "../pages/notifications/ScheduledNotificationsPage";
import NotificationLogsPage from "../pages/notifications/NotificationLogsPage";
import PrivacyPolicyPublicPage from "../pages/PrivacyPolicyPublicPage";
import TermsConditionPublicPage from "../pages/TermsConditionPublicPage";
import SystemErrorsPage from "../pages/systemErrors/SystemErrorsPage";

const AppRoutes: React.FC = () => (
    <Routes>
        <Route
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <MainLayout />
                </ProtectedRoute>
            }
        >
            <Route
                path="/admin"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <DashBoardPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/website-analytics"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <WebsiteAnalyticsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/play-reviews"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <PlayReviewsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/play-vitals"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <PlayVitalsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <AdvertisementPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <AdvertisementView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement/add"
                element={
                    <ProtectedRoute allowedRoles={[userRoles.SUPERADMIN]}>
                        <AdvertisementAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement/add/:userid"
                element={
                    <ProtectedRoute allowedRoles={[userRoles.SUPERADMIN]}>
                        <AdvertisementAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement/edit/:adid"
                element={
                    <ProtectedRoute allowedRoles={[userRoles.SUPERADMIN]}>
                        <AdvertisementAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/profiles"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProfilePage key="verified" pageTitle="Verified Profiles" />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/nonverifiedprofiles"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProfilePage key="nonverified" listEndpoint="/user/nonverifiedlist" pageTitle="Non Verified Profiles" />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/profiles/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProfileView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business/add"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business/edit/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business/viewers/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessViewers />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/stories"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <StoryPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/livevideos"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <DashBoardPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/matrimonial"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <MatriMonialPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/matrimonial/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <MatriMonialView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobDescPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc/add"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc/edit/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc/viewers/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobViewers />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products/viewers/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductViewers />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products/add"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products/edit/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/leads"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <NewLeadsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/subadmins"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <SubAdminPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/bloodgroup"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BloodGroupPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/activeusers"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ActiveUsersCards />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/activeusers/:screen"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ActiveUsersPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/chats"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ChatPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/reportactivities"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ReportActivitiesPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/settings"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <SettingPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/livesupport"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <LiveSupportPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/system-errors"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <SystemErrorsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/scheduled-notifications"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ScheduledNotificationsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/notification-logs/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <NotificationLogsPage />
                    </ProtectedRoute>
                }
            />
        </Route>
        <Route
            path="/admin/subcast"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SubCastPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/subcast/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SubCastCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/subcast/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SubCastCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/govtdepartment"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <GovtDepartmentPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/govtdepartment/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <GovtDepartmentCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/govtdepartment/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <GovtDepartmentCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarBhavPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarBhavCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarBhavCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav/view/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarBhavView />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/surnames"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SurnamePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/surnames/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SurnameCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/surnames/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SurnameCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/registrationdoc"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <RegDocPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/registrationdoc/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <RegDocCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businesstype"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessTypePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businesstype/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessTypeCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businesscategory"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessCategoryPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businesscategory/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessCategoryCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/registrationtype"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <RegTypePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/registrationtype/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <RegTypeCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/producttype"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <ProductTypePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/producttype/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <ProductTypeCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businessmemtag"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessMemTagPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businessmemtag/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessMemTagCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarproducts"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarProductPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarproducts/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarProductCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SettingPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/aboutus"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <AboutusPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/privacypolicy"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <PrivacyPolicyPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/livevideo"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <LiveVideoPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/livevideo/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <LiveVideoCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/livevideo/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <LiveVideoCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/event"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EventPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/event/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EventCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/event/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EventCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/pagevideo"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <PageVideoPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/homecontent"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <HomeContentPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/applicationsettings"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <ApplicationSettingsPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/contactus"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <ContactusPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/termsandcondition"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <TermsandConditionPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRulePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRuleCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRuleCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule/tree"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRuleTreeView />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule/tree/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRuleTreeView />
                </ProtectedRoute>
            }
        />

        <Route
            path="/admin/advertisementpackage"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <AdvertisementPakagePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/advertisementpackage/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <AdvertisementPakageCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/advertisementpackage/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <AdvertisementPakageCreate />
                </ProtectedRoute>
            }
        />

        <Route path="/" element={<HomePage />} />
        <Route path="/p/:slug" element={<PublicSitePage />} />
        <Route path="/privacypolicy" element={<PrivacyPolicyPublicPage />} />
        <Route path="/termsandcondition" element={<TermsConditionPublicPage />} />
        <Route path="enregister" element={<RegistrationCreateEn />} />
        <Route path="guregister" element={<RegistrationCreateGu />} />
        <Route path="/advertisement/:userid" element={<CreateAd />} />
        <Route path="/advertisement/:userid/my" element={<MyAdvertisements />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin/forgetpassword" element={<ForgetPasswordPage />} />

        {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
);

export default AppRoutes;
